export default "__VITE_ASSET__0f790d9c__"